import Api from "@/services/apiService";

class NotificationCountersApi {
  index() {
    return Api.getRequest(
      "notification/counters", {}, Api.authHeaders(), { skipErrorNotification: true }
    );
  }
}

export default new NotificationCountersApi();
